import React, { useRef, useState, useMemo, useEffect, useCallback } from 'react';
import { apiHolder, mailPerfTool, apis } from 'api';
import PageContentLayout from '@/layouts/Main/pageContentLayout';
import TabContentLayout from '@/layouts/Main/tabContentLayout';
import './mailBox.scss';
import { useAppDispatch, useAppSelector, useActions } from '@web-common/state/createStore';
import useState2RM from './hooks/useState2ReduxMock';
import FolderMoveModal from './components/FolderMoveModal/FolderMoveModal';
import ModuleHotKey from './components/ListHotKeys/moduleHotKey';
import MailBoxEventHander from './components/mailBoxEventHander/mailBoxEventHander';
import CustomerMailBoxEventHandler from '@web-mail/components/CustomerMail/customerMailBoxEventHandler';
import CustomerUIHandler from '@web-mail/components/CustomerMail/customerUIHandler';
import SubordinateUIHandler from '@web-mail/components/SubordinateMail/subordinateUIHandler';
import SubordinateMailBoxEventHandler from '@web-mail/components/SubordinateMail/subordinateMailBoxEventHandler';
import MailSyncModal from '@web-mail/components/MailSyncModal/MailSyncModal';
import { useLocation } from '@reach/router';
import TabWriteLetter from '@web-mail/components/TabWriteLetter/TabWriteLetter';
import LoadingImg from '@/images/app_bg_loading.gif';
import MailTab from './components/MailTab/MailTab';
import ReadMailPage from './readMailPage';
import AiAsstReadMailPage from './aiAsstReadMailPage';
import { tabType, WriteMailTypes, actions as mailTabActions, tabId } from '@web-common/state/reducer/mailTabReducer';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { FLOLDER, MAIL_STORE_REDUX_STATE } from './common/constant';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { dragTransFileHasEml } from './util';
import Loadable from '@loadable/component';
const QuickSetting = Loadable(() => import('./components/MailColumnEntry/quickSetting'));
import SurveySpace from './components/SurveySpace/SurveySpace';
import useDebounceForEvent from './hooks/useDebounceForEvent';
import useThrottleForEvent from './hooks/useThrottleForEvent';
import UrlToWriteMail from './UrlToWriteMail';
import { getIn18Text } from 'api';
import { AddToCustomerOrClue } from '@/components/Layout/CustomsData/components/uniDrawer/uniDrawerLeads2';
import ErrorModal from '@web-mail-write/components/SendMail/ErrorModal';
import { AiAssistantSidebarSd } from '@web-common/components/AiAssistant';
import { showColdRcModal, Module } from '@lxunit/app-l2c-crm';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
const MailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const storeApi = apiHolder.api.getDataStoreApi();
const MailBox = props => {
    const systemApi = apiHolder.api.getSystemApi();
    const inElectron = systemApi.isElectron();
    const MailBoxEventHandlerMemo = useMemo(() => React.createElement(MailBoxEventHander, null), []);
    const emlOverLock = useRef(true);
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const CustomerMailBoxEventHandlerMemo = useMemo(() => (process.env.BUILD_ISEDM || navigateVersion ? React.createElement(CustomerMailBoxEventHandler, null) : null), [navigateVersion]);
    const SubordinateMailBoxEventHandlerMemo = useMemo(() => React.createElement(SubordinateMailBoxEventHandler, null), []);
    const location = useLocation();
    const reducer = useActions(mailActions);
    const { doChangeCurrentMail } = mailActions;
    const [mailBoxActive, setMailBoxActive] = useState(false);
    const { currentTab, tabList } = useAppSelector(state => state.mailTabReducer);
    const [uniToCustomerOrClueParam, setUniToCustomerOrClueParam] = useState2RM('uniToCustomerOrClueParam');
    const [aiAssistSideBarEnable_sd] = useState2RM('aiAssistSideBarEnable_sd');
    const [aiAssistSideBarEnable_resign] = useState2RM('aiAssistSideBarEnable_resign');
    const CustomerUIHandlerMemo = useMemo(() => {
        if (process.env.BUILD_ISEDM || navigateVersion) {
            let sliceId = currentTab === null || currentTab === void 0 ? void 0 : currentTab.id;
            if (currentTab.type !== tabType.customer) {
                sliceId = tabId.readCustomer;
            }
            return React.createElement(CustomerUIHandler, { sliceId: sliceId });
        }
        return null;
    }, [currentTab === null || currentTab === void 0 ? void 0 : currentTab.id, navigateVersion]);
    const SubordinateUIHandlerMemo = useMemo(() => {
        let sliceId = currentTab === null || currentTab === void 0 ? void 0 : currentTab.id;
        if (currentTab.type !== tabType.subordinate) {
            sliceId = tabId.subordinate;
        }
        return React.createElement(SubordinateUIHandler, { sliceId: sliceId });
    }, [currentTab === null || currentTab === void 0 ? void 0 : currentTab.id]);
    const currentTabType = useMemo(() => currentTab.type, [currentTab]);
    const readTabList = useAppSelector(state => state.mailTabReducer.readTabList);
    const mailEntitiesMap = useAppSelector(state => state.mailReducer[MAIL_STORE_REDUX_STATE]);
    const tooltipVisible = useAppSelector(state => state.mailReducer.tooltipVisible);
    const TabWriteLetterRef = useRef(null);
    const tabListRef = useRef(tabList);
    tabListRef.current = tabList;
    const dispatch = useAppDispatch();
    const isEmlDragModel = useAppSelector(state => state.mailReducer.isDragModel === 'eml');
    useEffect(() => {
        if (WriteMailTypes.includes(currentTab.type)) {
            try {
                dispatch(doChangeCurrentMail(currentTab.id));
            }
            catch (error) {
                console.error(error);
            }
        }
    }, [currentTab === null || currentTab === void 0 ? void 0 : currentTab.id]);
    const onBeforeClose = useCallback((ids) => {
        var _a;
        const closePs = (_a = TabWriteLetterRef === null || TabWriteLetterRef === void 0 ? void 0 : TabWriteLetterRef.current) === null || _a === void 0 ? void 0 : _a.closeTab(ids);
        return new Promise((resolve) => {
            Promise.all([closePs])
                .then(values => {
                if (!values || values.length < 1)
                    return false;
                for (let i = 0; i < values.length; i++) {
                    if (!values[i]) {
                        resolve(false);
                        return false;
                    }
                }
                resolve(true);
                return true;
            })
                .catch(error => {
                console.log(getIn18Text('GUANBIBIAOQIANSHI'), error);
                resolve(false);
                return false;
            });
        });
    }, []);
    useEffect(() => {
        try {
            if (location.hash.indexOf('#mailbox') !== -1) {
                reducer.reDrawMailList();
                setMailBoxActive(true);
            }
            else {
                setMailBoxActive(false);
            }
        }
        catch (e) {
            console.error('[useEffect reDrawMailList err]', e);
        }
    }, [location.hash]);
    const dbClickReadTab = useCallback((id) => {
        const readTab = readTabList.find(item => item.id === id);
        let mail;
        if (readTab) {
            mail = mailEntitiesMap[readTab.currentMid];
        }
        else {
            mail = mailEntitiesMap[id];
        }
        if (mail) {
            const { isThread, _account, isTpMail, owner } = mail;
            mailPerfTool.mailContent('window', 'start', { isThread: !!isThread });
            if (process.env.BUILD_ISELECTRON) {
                if (mail.entry.folder === FLOLDER.DRAFT) {
                    MailApi.doEditMail(mail.id, { draft: true, _account: mail === null || mail === void 0 ? void 0 : mail._account });
                }
                else {
                    systemApi.createWindowWithInitData({ type: 'readMail', additionalParams: { account: _account } }, { eventName: 'initPage', eventData: { id: mail === null || mail === void 0 ? void 0 : mail.id, accountId: _account, isTpMail, owner }, eventStrData: 'clickTab' });
                }
            }
            else {
                window.open(`${systemApi.getContextPath()}/readMail/?id=${mail === null || mail === void 0 ? void 0 : mail.id}${_account ? '&account=' + _account : ''}${isThread ? '&isthread=1' : ''}${isTpMail ? '&isTpMail=1' : ''}${owner ? '&owner=' + owner : ''}`, 'readMail', 'menubar=0,scrollbars=1,resizable=1,width=800,height=600');
            }
            setTimeout(() => {
                dispatch(mailTabActions.doCloseTab(String(id)));
            }, 0);
        }
    }, [mailEntitiesMap, readTabList]);
    const onTabDbClick = useCallback((id) => {
        var _a;
        const curDbTab = (tabListRef.current || []).find(item => item.id === id);
        if (!curDbTab)
            return Promise.resolve(true);
        if (WriteMailTypes.includes(curDbTab.type)) {
            (_a = TabWriteLetterRef === null || TabWriteLetterRef === void 0 ? void 0 : TabWriteLetterRef.current) === null || _a === void 0 ? void 0 : _a.doubleCkTab(id);
        }
        if ([tabType.read].includes(curDbTab.type)) {
            dbClickReadTab(id);
        }
        return Promise.resolve(true);
    }, [dbClickReadTab]);
    const dbref = useCreateCallbackForEvent(onTabDbClick);
    const mailTab = useMemo(() => (React.createElement(TabContentLayout, { SideContentLayout: true, style: { height: 35, width: '100%', flex: 'none' }, className: `mail-tab-container` },
        React.createElement("div", { style: {
                display: 'flex',
                width: '100%',
                height: 36,
            } },
            React.createElement("div", { style: {
                    flex: 1,
                    width: 0,
                } },
                React.createElement(MailTab, { onBeforeClose: onBeforeClose, onDbClick: dbref }))))), []);
    useEffect(() => {
        mailConfApi.doGetUserAttr(['fillrcpts_when_replyall']).then(rs => {
            storeApi.putSync('ReplyAllContact', rs.fillrcpts_when_replyall, { noneUserRelated: true });
        });
    }, []);
    useEffect(() => {
        if (process.env.BUILD_ISEDM || navigateVersion) {
            showColdRcModal({ moduleName: Module.Email });
        }
    }, []);
    const [configMailShow] = useState2RM('configMailShow', 'doUpdateConfigMailShow');
    const QuickSettingMemo = configMailShow ? React.createElement(QuickSetting, null) : React.createElement(React.Fragment, null);
    const customerIframe = process.env.BUILD_ISEDM || navigateVersion ? (React.createElement(React.Fragment, null,
        React.createElement(AddToCustomerOrClue, Object.assign({}, uniToCustomerOrClueParam, { onOk: () => {
                if (uniToCustomerOrClueParam.onOk) {
                    uniToCustomerOrClueParam.onOk();
                }
                setUniToCustomerOrClueParam({ visible: false });
            }, onCancel: () => {
                if (uniToCustomerOrClueParam.onCancel) {
                    uniToCustomerOrClueParam.onCancel();
                }
                setUniToCustomerOrClueParam({ visible: false });
            } })))) : (React.createElement(React.Fragment, null));
    const [folderModveModalVisiable] = useState2RM('folderModveModalVisiable', 'doUpdateFolderModveModalVisiable');
    const ComFolderMoveModal = folderModveModalVisiable ? React.createElement(FolderMoveModal, null) : [];
    const PageContentLayoutHeight = useMemo(() => {
        if (systemApi.isWebWmEntry()) {
            return 'calc(100vh - 54px)';
        }
        if (!process.env.BUILD_ISELECTRON) {
            return process.env.BUILD_ISEDM ? '100vh' : 'calc(100vh - 47px)';
        }
        return '100vh';
    }, []);
    const debounceCloseEmlDragModel = useDebounceForEvent(() => {
        emlOverLock.current = true;
        reducer.updateOuterFileDragLeave({});
    }, 800, {
        leading: false,
    });
    const handleOuterDragOver = useCallback((event) => {
        if (!isEmlDragModel && emlOverLock.current) {
            let couldDrop = dragTransFileHasEml(event);
            if (couldDrop) {
                emlOverLock.current = false;
                reducer.updateOuterFileDragEntry({});
            }
        }
        debounceCloseEmlDragModel();
    }, []);
    const throttleHandleOuterDragOver = useThrottleForEvent(handleOuterDragOver, 500);
    return (React.createElement("div", { style: { display: 'flex', flex: '1 1 0%', overflow: 'hidden' }, onDragOverCapture: event => {
            event.persist();
            throttleHandleOuterDragOver(event);
        } },
        React.createElement(ModuleHotKey, null,
            React.createElement(PageContentLayout, { id: "mailboxModule", className: `mailtab-layout ${!inElectron ? 'mailtab-layout-web' : ''}`, style: {
                    height: PageContentLayoutHeight,
                } },
                mailTab,
                React.createElement("div", { style: { display: 'flex', width: '100%', height: 'calc(100% - 35px)' }, "data-sidecontent": true },
                    React.createElement("div", { className: `tab-read-page ${systemApi.isWebWmEntry() ? 'wm-web-tab-read-page' : ''}`, hidden: ![tabType.read, tabType.readMain, tabType.customer, tabType.subordinate].includes(currentTabType), SideContentLayout: true, style: { height: '100%' } },
                        React.createElement(ReadMailPage, Object.assign({}, props, { active: mailBoxActive }))),
                    React.createElement("div", { className: `tab-read-page ${systemApi.isWebWmEntry() ? 'wm-web-tab-read-page' : ''}`, hidden: ![tabType.aiAssistant].includes(currentTabType), SideContentLayout: true, style: { height: '100%' } },
                        React.createElement(AiAsstReadMailPage, Object.assign({}, props, { active: mailBoxActive }))),
                    React.createElement("div", { className: `tab-write-page ${systemApi.isWebWmEntry() ? 'wm-web-tab-write-page' : ''} ${!inElectron ? 'tab-write-page-web' : ''}`, hidden: !WriteMailTypes.includes(currentTabType), SideContentLayout: true },
                        React.createElement(TabWriteLetter, { ref: TabWriteLetterRef })),
                    React.createElement("div", { className: `tab-write-page ${!process.env.BUILD_ISELECTRON ? 'tab-write-page-web' : ''}`, hidden: !(currentTabType === tabType.temp), SideContentLayout: true },
                        React.createElement("div", { className: "tab-loading" }, currentTabType === tabType.temp ? React.createElement("img", { className: "loading-img", src: LoadingImg }) : null)),
                    React.createElement(ErrorBoundary, { name: "AiAssistantSidebar" }, process.env.BUILD_ISWEB && React.createElement(AiAssistantSidebarSd, null)))),
            ComFolderMoveModal,
            MailBoxEventHandlerMemo,
            CustomerMailBoxEventHandlerMemo,
            CustomerUIHandlerMemo,
            SubordinateMailBoxEventHandlerMemo,
            SubordinateUIHandlerMemo,
            QuickSettingMemo,
            customerIframe,
            React.createElement(MailSyncModal, null),
            React.createElement(SurveySpace, null),
            React.createElement(UrlToWriteMail, null),
            tooltipVisible && React.createElement(ErrorModal, { cond: "mailBox" }))));
};
export default MailBox;
